// extracted by mini-css-extract-plugin
module.exports = {"content":"style_content__22vfO","con":"style_con__2zs2D","img":"style_img__1EUmt"};